<template>
  <main>
<!--    <div class="app-title">-->
<!--      <div>-->
<!--        <h1>-->
<!--          <font-awesome-icon icon="comments"/>-->
<!--          {{ $t('znsHistory') }}-->
<!--        </h1>-->
<!--      </div>-->
<!--    </div>-->
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <client-select :model="filterFormModel" class="mr-1 mb-1" attribute="client" @change="search" :isFilter="true" :place-holder="$t('selectClient') " ></client-select>
            <social-net-work-account-select :model="filterFormModel" class="mr-1 mb-1" attribute="oa" @change="search" :isFilter="true" :filter="oaFilter" :is-filter="true"/>
            <form-select :model="filterFormModel" attribute="type" class="mr-1 mb-2" :options="[
                        {text: this.$t('znsType'), value: null},
                        {text: this.$t('text'), value: 'text'},
                        {text: this.$t('table'), value: 'table'},
                        {text: this.$t('otp'), value: 'otp'},
                      ]"></form-select>
            <form-select :model="filterFormModel" attribute="status" class="mr-1 mb-2" :options="[
              {value: null, text: $t('status')},
              {value: 'sending', text: $t('notYetSent')},
              {value: 'success', text: $t('success')},
              {value: 'fail', text: $t('error')}
            ]"></form-select>
            <form-input class="mr-1 mb-2" :model="filterFormModel" attribute="number" v-on:keydown.enter="load"
                          :placeholder="$t('toNumber')"></form-input>
            <time-range-picker :model="filterFormModel" :label="$t('time')" class="mr-1 mb-2" :defaultShortcut="3"></time-range-picker>

            <button @click="load" class="btn btn-primary mr-1 mb-2">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-2">Reset</button>

            <history-export v-if="['owner','admin', 'tech' , 'operationsManager', 'account'].includes($store.state.user.role)" :filter="filterFormModel" :total-count="itemCount"/>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                            @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-2">{{ $t('from') }}</div>
            <div class="col-lg-2 text-center">{{ $t('to') }}</div>
            <div class="col-lg-4">{{ $t('time') }}</div>
            <div class="col-lg-3">{{ $t('content') }}</div>
            <div class="col-lg-1"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-2">
              <p><b>{{ $t('client') }}: </b><span>{{ item.client.domain }}</span></p>
              <p v-if="item.oa">
                <b class="text-gray-999">OA : </b>
                <span>{{ item.oa.name }}</span>
              </p>
              <p v-if="item.user">
                <b class="text-gray-999">{{ $t('user') }}: </b>
                <span>{{ item.user.name }} ({{item.user.ext}})</span>
              </p>
            </div>
            <div class="col-lg-2 text-center">
              <p v-if="item.phone">{{ item.phone }}</p>
            </div>
            <div class="col-lg-4">
              <p>
                <b class=" text-gray-999">{{ $t('createTime') }}:&nbsp;</b>
                <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
              <p v-if="item.sendTime">
                <b class=" text-gray-999">{{ $t('sendTime') }}:&nbsp;</b>
                <span>{{ item.sendTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
              <p v-if="item.chargeTime">
                <b>{{ $t('chargeTime') }}:&nbsp;</b><span>{{ item.sendTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
              <p v-if="item.chargedFee">
                <b>{{ $t('chargedFee') }}:&nbsp;</b><span class="text-danger">{{ item.chargedFee | numFormat }}<sup>{{ item.client.country.currency }}</sup></span>
              </p>
            </div>
            <div class="col-lg-3">
              <template v-if="item.template">
                <p>
                  <span class="text-gray-999 small">{{ $t('template') }}: </span>
                  <span>{{item.template.name}}</span>
                  <a v-if="item.template.previewUrl" :href="item.template.previewUrl" target="_blank" class="small"> {{$t('seeTemplate')}}</a>
                </p>
              </template>
              <p>
                <span class="text-gray-999 small">{{ $t('type') }}: </span>
                <span class="badge" :class="item.type === 'otp' ? 'badge-info' : 'badge-primary'">{{ $t(item.type) }}</span>
              </p>
              <p>
                <span class="text-gray-999 small">{{ $t('status') }}: </span>
                <span class="badge badge-warning" v-if="!item.sendTime">{{ $t('notYetSent') }}</span>
                <span class="badge badge-success" v-if="item.sendTime && !item.sendError">{{ $t('success') }}</span>
                <span class="badge badge-danger" v-if="item.sendTime && item.sendError">{{ $t('error') }}</span>
                &nbsp;<span v-if="item.sendErrorMsg" class="text-gray-999 small">{{ item.sendErrorMsg }}</span>
              </p>
              <p v-if="item.developmentMode">
                <span class="badge badge-secondary">Development mode</span>
              </p>
            </div>
            <div class="col-lg-1">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
              <button @click="$refs.znsContent.show(item.template, item.params, item.oa.name)" class="btn btn-info btn-sm">
                <i class="fa fa-info"></i>
              </button>
            </div>
            </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">{{ $t('notFoundSearch') }}</div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <z-n-s-content ref="znsContent"></z-n-s-content>
  </main>
</template>

<script>
import list from '../../mixins/List';
import utils from '../../utils';
import ClientSelect from "@/components/ClientSelect";
import TimeRangePicker from "../../components/TimeRangePicker";
import SocialNetWorkAccountSelect from "@/components/SocialNetWorkAccountSelect";
import HistoryExport from "./HistoryExport";
import _ from 'lodash';
import ZNSContent from "./Content";

export default {
  components: {TimeRangePicker, ClientSelect, SocialNetWorkAccountSelect, HistoryExport, ZNSContent},
  mixins: [list, utils],
  data() {
    return {
      userRole: this.$store.state.user.role,
      service: '/zns',
      autoLoad: true,
      oaFilter: {
        type: "zalo",
        client: null
      },
      defaultFilterFormModel: {
        client: null,
        brandName: null,
        type: null,
        status: null
      }
    }
  },
  watch: {
    "filterFormModel.client": {
      handler(val) {
        this.oaFilter.client = val;
      }
    }
  },
  methods: {
    search: _.debounce(function () {
                this.filterFormModel.page = 1;
                this.load();
            }, 200),
  },
  i18n: {
    messages: {
      en: {
        from: 'Sent from',
        to: 'Sent to',
        smsContent: 'SMS content',
        smsStatus: 'SMS status',
        createTime: 'Create time',
        sendTime: 'Send time',
        chargeTime: 'Charge time',
        chargedFee: 'Charged fee',
        notYetSent: 'Not yet sent',
        toNumber: 'Send to number',
        care: 'Care',
        ads: 'Ads',
        smsType: 'Type',
        viberHistory: 'Viber history',
        number: 'Number'
      },
      vi: {
        from: 'Gửi từ',
        to: 'Gửi tới',
        smsContent: 'Nội dung',
        smsStatus: 'Trạng thái',
        createTime: 'Tạo lúc',
        sendTime: 'Gửi lúc',
        chargeTime: 'Tính tiền lúc',
        chargedFee: 'Số tiền',
        notYetSent: 'Chưa gửi',
        toNumber: 'Gửi tới số',
        care: 'CSKH',
        ads: 'Quảng cáo',
        smsType: 'Loại',
        viberHistory: 'Lịch sử viber',
        number: 'Số điện thoại',

        znsHistory: "Lịch sử ZBS",
        znsType: "Phân loại",
        template: "Mẫu tin nhắn",
        text: "Văn bản",
        table: "Dạng bảng",
        otp: "OTP"
      }
    }
  }
}
</script>